

// types
import type { TDisplayConfig } from "@/types";

export const DEFAULT_DISPLAY_CONFIG: TDisplayConfig = {
  fontSize: "large-font",
  fontStyle: "sans-serif",
  lineSpacing: "regular",
  wideLayout: false,
};

export const ACCEPTED_IMAGE_MIME_TYPES = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/webp",
  "image/gif",
];

export const ACCEPTED_ATTACHMENT_MIME_TYPES = [
  "image/jpeg",
  "image/png",
  "image/gif",
  "image/svg+xml",
  "image/webp",
  "image/tiff",
  "image/bmp",
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.ms-powerpoint",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  "text/plain",
  "text/markdown",
  "application/rtf",
  "audio/mpeg",
  "audio/wav",
  "audio/ogg",
  "audio/midi",
  "audio/x-midi",
  "audio/aac",
  "audio/flac",
  "audio/x-m4a",
  "video/mp4",
  "video/mpeg",
  "video/ogg",
  "video/webm",
  "video/quicktime",
  "video/x-msvideo",
  "video/x-ms-wmv",
  "application/zip",
  "application/x-rar-compressed",
  "application/x-tar",
  "application/gzip",
  "model/gltf-binary",
  "model/gltf+json",
  "application/octet-stream",
  "font/ttf",
  "font/otf",
  "font/woff",
  "font/woff2",
  "text/css",
  "text/javascript",
  "application/json",
  "text/xml",
  "text/csv",
  "application/xml",
];
